import type { FieldDefinition } from '@/components/objects/typedFieldData';
import type { ObjectFormSection, ObjectFormValues } from '@/components/object-forms/formData';
export const FORM_HOME = '/design/object-forms';
export const FORM_DEFINITIONS: readonly FieldDefinition[] = [
  {
    id: 'title',
    label: 'Название',
    type: 'text',
    maxLength: 160,
    required: true,
    help: 'Коротко опиши, что нужно сделать.',
  },
  {
    id: 'category',
    label: 'Категория',
    type: 'select',
    required: true,
    options: [
      { id: 'review', label: 'Проверка', tone: 'info' },
      { id: 'maintenance', label: 'Обслуживание', tone: 'neutral' },
      { id: 'delivery', label: 'Поставка', tone: 'success' },
    ],
  },
  {
    id: 'importance',
    label: 'Важность',
    type: 'importance',
    options: [
      { id: 'low', label: 'Низкая', level: 1, tone: 'neutral' },
      { id: 'normal', label: 'Обычная', level: 2, tone: 'info' },
      { id: 'high', label: 'Высокая', level: 3, tone: 'warn' },
    ],
  },
  {
    id: 'owner',
    label: 'Ответственный',
    type: 'person',
    required: true,
    options: [
      { id: 'person-1', label: 'Эля Светлова', kind: 'user' },
      { id: 'person-2', label: 'Тим Лесной', kind: 'user' },
      { id: 'person-3', label: 'Ника Озерова', kind: 'user' },
    ],
  },
  { id: 'email', label: 'Почта для ответа', type: 'email', help: 'Необязательное поле.' },
  { id: 'description', label: 'Описание', type: 'multiline', maxLength: 4000 },
  { id: 'period', label: 'Период', type: 'period' },
  { id: 'budget', label: 'Бюджет', type: 'money', currency: 'RUB' },
  { id: 'tags', label: 'Теги', type: 'tags', maxTags: 6 },
  { id: 'notify', label: 'Прислать результат', type: 'checkbox' },
];
export const FORM_SECTIONS: readonly ObjectFormSection[] = [
  {
    id: 'basics',
    title: 'Основа',
    description: 'Название, категория и важность.',
    fieldIds: ['title', 'category', 'importance'],
  },
  {
    id: 'people',
    title: 'Ответственность',
    description: 'Кто ведёт запись и как связаться.',
    fieldIds: ['owner', 'email', 'description'],
  },
  {
    id: 'terms',
    title: 'Условия',
    description: 'Сроки, сумма и дополнительные настройки.',
    fieldIds: ['period', 'budget', 'tags', 'notify'],
  },
];
export function initialFormValues(record: 'new' | 'edit'): ObjectFormValues {
  return {
    title: { type: 'text', value: record === 'edit' ? 'Проверка учебного стенда' : null },
    category: { type: 'select', value: record === 'edit' ? 'review' : null },
    importance: { type: 'importance', value: 'normal' },
    owner: {
      type: 'person',
      value: record === 'edit' ? { id: 'person-1', label: 'Эля Светлова', kind: 'user' } : null,
    },
    email: { type: 'email', value: record === 'edit' ? 'elya@example.test' : null },
    description: {
      type: 'multiline',
      value:
        record === 'edit'
          ? 'Проверить комплектность и записать результат. Все данные в этом образце вымышлены.'
          : null,
    },
    period: { type: 'period', value: record === 'edit' ? { from: '2026-10-26', to: '2026-10-30' } : null },
    budget: { type: 'money', value: { minorUnits: 0, currency: 'RUB' } },
    tags: { type: 'tags', value: record === 'edit' ? ['учебный', 'проверка'] : [] },
    notify: { type: 'checkbox', value: false },
  };
}
